import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const StopWatchIcon = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 16 16" fill="none" title={t`Stop Watch`} {...props}>
      <Path
        fill="currentColor"
        d="M8 2.25A6.75 6.75 0 1 1 1.25 9a.75.75 0 0 1 1.5 0 5.25 5.25 0 1 0 2.707-4.594.75.75 0 0 1-.728-1.312A6.723 6.723 0 0 1 8 2.25Zm-.5 3a.75.75 0 0 1 .75.75v3.19l1.28 1.28a.75.75 0 1 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1-.22-.53V6a.75.75 0 0 1 .75-.75Zm4.97-2.78a.75.75 0 0 1 1.06 0l1.5 1.5a.75.75 0 0 1-1.06 1.06l-1.5-1.5a.75.75 0 0 1 0-1.06ZM9 .25a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1 0-1.5h2Z"
      />
    </Icon>
  );
};
